import {ItemConfiguracao} from './../../../model/catalogo';
import {Component, OnInit, HostListener} from '@angular/core';
import {GlobalService} from './../../../service/global.service';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {
    FormGroup,
    FormControl,
    FormBuilder,
    Validators,
} from '@angular/forms';
import {ModalService} from '../../../service/modal.service';
import {CatalogoApiService} from '../../../service/api/catalogo.api';
import {Router, ActivatedRoute} from '@angular/router';
import {
    Operacao,
    ParametroEntradaOperacao,
    ParametroSaidaOperacao,
    ReturnCode,
} from '../../../model/catalogo';
import {Subscription} from 'rxjs/Subscription';
import {DetalhamentoApiService} from '../../../service/api/detalhamento.api';
import {t} from '@angular/core/src/render3';

@Component({
    selector: 'app-parametro-entrada-modal',
    templateUrl: './parametro-entrada-modal.component.html',
    styleUrls: ['./parametro-entrada-modal.component.css'],
})
export class ParametroEntradaModalComponent implements OnInit {
    modoEdicao: Boolean = false;
    collapseNovo: boolean = false;
    collapseNovoSaida: boolean = false;
    collapseReturnCode: boolean = false;
    paramsSubscription: Subscription = null;

    nome = new FormControl('', []);
    descricao = new FormControl('', []);
    tipoEdicao = new FormControl('0', []);
    codigo: number = null;
    versao: number = null;
    titulo: string;
    edicaoEntrada: number = null;
    edicaoSaida: number = null;
    edicaoReturnCode: number = null;

    parmNome = new FormControl('', []);
    parmDesc = new FormControl('', []);
    paramTipo = new FormControl('', []);
    paramSubtipo = new FormControl('', []);
    paramObrigatorio = new FormControl('', []);
    conteudoPadrao = new FormControl('', []);

    parmSaidaNome = new FormControl('', []);
    parmSaidaDesc = new FormControl('', []);
    paramSaidaTipo = new FormControl('', []);
    paramSaidaSubtipo = new FormControl('', []);

    paramReturnCodeNum = new FormControl('', []);
    paramReturnCodeDesc = new FormControl('', []);

    operacaoForm: FormGroup = this.formBuilder.group({
        nome: this.nome,
        descricao: this.descricao,
    });
    parametroReturnCodeForm: FormGroup = this.formBuilder.group({
        paramReturnCodeNum: this.paramReturnCodeNum,
        paramReturnCodeDesc: this.paramReturnCodeDesc,
    });
    conteudoPadraoForm: FormGroup = this.formBuilder.group({
        conteudoPadrao: this.conteudoPadrao,
    });
    parametroForm: FormGroup = this.formBuilder.group({
        parmNome: this.parmNome,
        parmDesc: this.parmDesc,
        paramTipo: this.paramTipo,
        paramSubtipo: this.paramSubtipo,
        paramObrigatorio: this.paramObrigatorio,
    });
    parametroSaidaForm: FormGroup = this.formBuilder.group({
        parmSaidaNome: this.parmSaidaNome,
        parmSaidaDesc: this.parmSaidaDesc,
        paramSaidaTipo: this.paramSaidaTipo,
        paramSaidaSubtipo: this.paramSaidaSubtipo,
    });

    novaOperacao: Operacao = new Operacao();
    novoParametro: ParametroEntradaOperacao = new ParametroEntradaOperacao();
    listaParametrosEntrada: Array<ParametroEntradaOperacao> =
        new Array<ParametroEntradaOperacao>();
    novoParametroSaida: ParametroSaidaOperacao = new ParametroSaidaOperacao();
    listaParametrosSaida: Array<ParametroSaidaOperacao> =
        new Array<ParametroSaidaOperacao>();
    listaConteudoPadrao: Array<string> = new Array<string>();
    novoParametroReturnCode: ReturnCode = new ReturnCode();
    listaParametrosReturnCode: Array<ReturnCode> = new Array<ReturnCode>();

    constructor(
        public pesquisaService: PesquisasFiltroApiService,
        public globalService: GlobalService,
        private router: Router,
        private route: ActivatedRoute,
        public modalService: ModalService,
        private formBuilder: FormBuilder,
        private catalogoService: CatalogoApiService,
        public detalhamentoApiService: DetalhamentoApiService
    ) {
    }

    resultados: Array<ItemConfiguracao>;

    ngOnInit() {
        this.paramsSubscription = this.route.queryParams.subscribe((params) => {
            if (params['codigo'] != undefined) {
                this.modoEdicao = true;
                this.novaOperacao.codigo = params['codigo'];
                this.novaOperacao.versao = params['versao'];
                this.getDadosOperacao(params['codigo'], params['versao']);
                this.titulo = 'Editar Operação';
            } else {
                this.titulo = 'Nova Operação';
            }
        });
    }

    pesquisa() {
        this.paramsSubscription = this.route.queryParams.subscribe((params) => {
            if (params['codigo'] != undefined) {
                this.modoEdicao = true;
                this.novaOperacao.codigo = params['codigo'];
                this.novaOperacao.versao = params['versao'];
                this.getDadosOperacao(params['codigo'], params['versao']);
                this.titulo = 'Editar Operação';
            } else {
                this.titulo = 'Nova Operação';
            }
        });
    }


    getDadosOperacao(codigo: number, versao: number) {
        this.detalhamentoApiService.detalhaOperacao(codigo, versao).subscribe(
            (response) => {
                this.codigo = response.codigo;
                this.versao = response.versao;
                this.nome.setValue(response.nome.trim());
                this.descricao.setValue(response.descricao.trim());
                this.listaParametrosEntrada = [];
                this.listaParametrosEntrada = response.parmEntrada;
                this.listaParametrosSaida = [];
                this.listaParametrosSaida = response.parmSaida;
                this.listaParametrosReturnCode = [];
                this.listaParametrosReturnCode = response.returnCode;
            },
            (erro) => {
            }
        );
    }

    editarParametroEntrada(indice: number) {
        let dados = this.listaParametrosEntrada[indice];
        this.parmNome.setValue(dados.nome);
        this.parmDesc.setValue(dados.descricao);
        this.paramTipo.setValue(dados.nomeTipoDado);
        this.paramSubtipo.setValue(dados.nomeSubtipoDado);
        this.listaConteudoPadrao = dados.conteudoPadrao;
        if (dados.obrigatorio == true) {
            this.paramObrigatorio.setValue('1');
        } else {
            this.paramObrigatorio.setValue('0');
        }
        this.edicaoEntrada = indice;
        this.collapseNovo = true;
    }

    removerConteudoPadrao(indice: number) {

        this.catalogoService
            .removerConteudoPadraoDeParametroEntrada(
                this.operacaoForm.value.nome,
                this.parametroForm.value.parmNome,
                this.listaConteudoPadrao[indice]
            )
            .subscribe(
                (resposta) => {
                    this.listaConteudoPadrao.splice(indice, 1);
                    this.pesquisa();
                },
                (erro) => {
                    if (erro.status == 400) {
                        this.modalService.exibirMensagem(
                            'Operação',
                            'Erro ao remover parametro.<br />',
                            'Fechar'
                        );
                    } else if (erro.status == 401) {
                        this.modalService.exibirMensagem(
                            'Operação',
                            'Erro ao remover parametro.<br />Token de autenticação fora do formato esperado, inválido ou expirado.',
                            'Fechar'
                        );
                    } else if (erro.status == 403) {
                        this.modalService.exibirMensagem(
                            'Operação',
                            'Erro ao remover parametro.<br />Usuário não possui permissão para efetuar essa operação.',
                            'Fechar'
                        );
                    } else if (erro.status == 409) {
                        this.modalService.exibirMensagem(
                            'Operação',
                            'Erro ao remover parametro.<br />Código/Versão incorretos.',
                            'Fechar'
                        );
                    } else {
                        this.modalService.exibirMensagem(
                            'Operação',
                            'Erro ao remover parametro.<br />Erro interno do servidor.',
                            'Fechar'
                        );
                    }
                }
            );
    }

    addConteudoPadrao() {
        this.catalogoService
            .editarConteudoPadraoDeParametroEntrada(
                this.operacaoForm.value.nome,
                this.parametroForm.value.parmNome,
                this.conteudoPadraoForm.value.conteudoPadrao
            )
            .subscribe(
                (resposta) => {
                    this.listaConteudoPadrao.push(this.conteudoPadraoForm.value.conteudoPadrao);
                    this.conteudoPadraoForm.controls['conteudoPadrao'].reset();
                    this.pesquisa();
                },
                (erro) => {
                    if (erro.status == 400) {
                        this.modalService.exibirMensagem(
                            'Operação',
                            'Erro ao cadastrar operação.<br />Verifique se os campos foram preenchidos corretamente.',
                            'Fechar'
                        );
                    } else if (erro.status == 401) {
                        this.modalService.exibirMensagem(
                            'Operação',
                            'Erro ao cadastrar operação.<br />Token de autenticação fora do formato esperado, inválido ou expirado.',
                            'Fechar'
                        );
                    } else if (erro.status == 403) {
                        this.modalService.exibirMensagem(
                            'Operação',
                            'Erro ao cadastrar operação.<br />Usuário não possui permissão para efetuar essa operação.',
                            'Fechar'
                        );
                    } else if (erro.status == 409) {
                        this.modalService.exibirMensagem(
                            'Operação',
                            'Erro ao cadastrar operação.<br />Código/Versão incorretos.',
                            'Fechar'
                        );
                    } else {
                        this.modalService.exibirMensagem(
                            'Operação',
                            'Erro ao cadastrar operação.<br />Erro interno do servidor.',
                            'Fechar'
                        );
                    }
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/modal/parametro-entrada-moldal/parametro-entrada-modal.component.ts